import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileFormat'
})
export class MobileFormatPipe implements PipeTransform {

  transform(value: string): string {
    // Check if the value is valid
    if (!value) return '';

    // Remove any non-numeric characters
    const numericValue = value.replace(/\D/g, '');
    let formattedValue = "";

    if (numericValue) {
      // Format the mobile number as per Indian standard
      formattedValue = numericValue.startsWith("91")
        ? `+${numericValue.replace(/(\d{5})(\d{5})/, '$1 $2')}`
        : `+91 ${numericValue.replace(/(\d{5})(\d{5})/, '$1 $2')}`;
    }
    return formattedValue;
  }
}
